import { LoadingOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { PrimaryColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconLoadingOutlined: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <LoadingOutlined {...props} style={{ ...props.style, color: PrimaryColor }} />;
};
